export const displayBalance = (value) => {
  if (typeof value !== "string" || !/^\d+\.\d{2}$/.test(value)) return "—";
  const [whole, fraction] = value.split(".");
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${fraction}`;
};
